import React, { useEffect, useState } from "react";
import {
  VERTEX360_COPILOT_RESPONDING_LABEL,
  VERTEX360_COPILOT_THINKING_STEP_MS,
  VERTEX360_COPILOT_THINKING_STEPS,
} from "../constants/vertex360CopilotConstants";
import Vertex360CopilotAiIcon from "./Vertex360CopilotAiIcon";

/**
 * Lightweight wait state before the first stream chunk —
 * icon + rotating status + typing dots inline with the chat.
 */
const AgentTypingIndicator = () => {
  const [stepIndex, setStepIndex] = useState(0);
  const [fadeKey, setFadeKey] = useState(0);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const reducedMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    )?.matches;
    if (reducedMotion || VERTEX360_COPILOT_THINKING_STEPS.length < 2) {
      return undefined;
    }

    const id = window.setInterval(() => {
      setStepIndex((prev) => (prev + 1) % VERTEX360_COPILOT_THINKING_STEPS.length);
      setFadeKey((prev) => prev + 1);
    }, VERTEX360_COPILOT_THINKING_STEP_MS);

    return () => window.clearInterval(id);
  }, []);

  const statusText =
    VERTEX360_COPILOT_THINKING_STEPS[stepIndex] ||
    VERTEX360_COPILOT_RESPONDING_LABEL;

  return (
    <div
      className="copilot-message-enter flex items-center gap-2.5"
      role="status"
      aria-live="polite"
      aria-label={VERTEX360_COPILOT_RESPONDING_LABEL}
    >
      <Vertex360CopilotAiIcon animated size="md" />
      <div className="flex min-w-0 items-center gap-2">
        <span className="copilot-thinking-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
        <p
          key={fadeKey}
          className="copilot-thinking-status truncate text-[13px] font-medium leading-snug text-[#293F6A]"
        >
          {statusText}
        </p>
      </div>
    </div>
  );
};

export default AgentTypingIndicator;
